/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_appSettings/route'
import { Route as AuthenticationRouteRouteImport } from './routes/_authentication/route'
import { Route as PublicRouteRouteImport } from './routes/_public/route'
import { Route as SettingsRouteRouteImport } from './routes/settings/route'
import { Route as SuperUserRouteRouteImport } from './routes/super-user/route'
import { Route as AuthenticationForgotPasswordRouteImport } from './routes/_authentication/forgot-password'
import { Route as AuthenticationLoginRouteImport } from './routes/_authentication/login'
import { Route as AuthenticationLogoutRouteImport } from './routes/_authentication/logout'
import { Route as AuthenticationResetPasswordRouteImport } from './routes/_authentication/reset-password'
import { Route as PublicAcceptInvitationRouteImport } from './routes/_public/accept-invitation'
import { Route as PublicHandleRouteImport } from './routes/_public/handle'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SettingsSecurityRouteImport } from './routes/settings/security'
import { Route as SettingsUserRouteImport } from './routes/settings/user'
import { Route as SettingsUsersRouteImport } from './routes/settings_.users'
import { Route as SuperUserIndexRouteImport } from './routes/super-user/index'
import { Route as AppCompanyIdIndexRouteImport } from './routes/_app/$companyId/index'
import { Route as AppCompanyIdAnalyticsRouteRouteImport } from './routes/_app/$companyId/analytics/route'
import { Route as AppCompanyIdHelpRouteImport } from './routes/_app/$companyId/help'
import { Route as AppCompanyIdNotAuthorizedRouteImport } from './routes/_app/$companyId/not-authorized'
import { Route as AppCompanyIdPurchaseOrdersRouteRouteImport } from './routes/_app/$companyId/purchase-orders/route'
import { Route as AppSettingsCompanyIdSettingsRouteRouteImport } from './routes/_appSettings/$companyId/settings/route'
import { Route as PublicWorkRequestCompanyIdRouteImport } from './routes/_public/work-request/$companyId'
import { Route as SuperUserBugReportsIndexRouteImport } from './routes/super-user/bug-reports/index'
import { Route as SuperUserCompaniesIndexRouteImport } from './routes/super-user/companies/index'
import { Route as SuperUserCompaniesCompanyIdRouteImport } from './routes/super-user/companies/$companyId'
import { Route as SuperUserHelpContentIndexRouteImport } from './routes/super-user/help-content/index'
import { Route as SuperUserPermissionDefaultsIndexRouteImport } from './routes/super-user/permission-defaults/index'
import { Route as SuperUserUsersIndexRouteImport } from './routes/super-user/users/index'
import { Route as SuperUserUsersUserIdRouteImport } from './routes/super-user/users/$userId'
import { Route as AppCompanyIdAnalyticsIndexRouteImport } from './routes/_app/$companyId/analytics/index'
import { Route as AppCompanyIdAnalyticsAssetsRouteImport } from './routes/_app/$companyId/analytics/assets'
import { Route as AppCompanyIdAnalyticsEmployeesRouteImport } from './routes/_app/$companyId/analytics/employees'
import { Route as AppCompanyIdAnalyticsWorkOrdersRouteImport } from './routes/_app/$companyId/analytics/work-orders'
import { Route as AppCompanyIdAssetsIndexRouteImport } from './routes/_app/$companyId/assets/index'
import { Route as AppCompanyIdAssetsAssetIdRouteImport } from './routes/_app/$companyId/assets/$assetId'
import { Route as AppCompanyIdAutomationsIndexRouteImport } from './routes/_app/$companyId/automations/index'
import { Route as AppCompanyIdAutomationsAutomationIdRouteImport } from './routes/_app/$companyId/automations/$automationId'
import { Route as AppCompanyIdMetersIndexRouteImport } from './routes/_app/$companyId/meters/index'
import { Route as AppCompanyIdMetersMeterIdRouteImport } from './routes/_app/$companyId/meters/$meterId'
import { Route as AppCompanyIdPartsIndexRouteImport } from './routes/_app/$companyId/parts/index'
import { Route as AppCompanyIdPartsPartIdRouteImport } from './routes/_app/$companyId/parts/$partId'
import { Route as AppCompanyIdPeriodicMaintenancesIndexRouteImport } from './routes/_app/$companyId/periodic-maintenances/index'
import { Route as AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRouteImport } from './routes/_app/$companyId/periodic-maintenances/$periodicMaintenanceId'
import { Route as AppCompanyIdProceduresIndexRouteImport } from './routes/_app/$companyId/procedures/index'
import { Route as AppCompanyIdProceduresProcedureIdRouteImport } from './routes/_app/$companyId/procedures/$procedureId'
import { Route as AppCompanyIdPurchaseOrdersIndexRouteImport } from './routes/_app/$companyId/purchase-orders/index'
import { Route as AppCompanyIdPurchaseOrdersOrderIdRouteImport } from './routes/_app/$companyId/purchase-orders/$orderId'
import { Route as AppCompanyIdVendorsIndexRouteImport } from './routes/_app/$companyId/vendors/index'
import { Route as AppCompanyIdVendorsVendorIdRouteImport } from './routes/_app/$companyId/vendors/$vendorId'
import { Route as AppCompanyIdWorkOrderTemplatesIndexRouteImport } from './routes/_app/$companyId/work-order-templates/index'
import { Route as AppCompanyIdWorkOrderTemplatesTemplateIdRouteImport } from './routes/_app/$companyId/work-order-templates/$templateId'
import { Route as AppCompanyIdWorkOrdersIndexRouteImport } from './routes/_app/$companyId/work-orders/index'
import { Route as AppCompanyIdWorkOrdersWorkOrderIdRouteImport } from './routes/_app/$companyId/work-orders/$workOrderId'
import { Route as AppCompanyIdWorkRequestsIndexRouteImport } from './routes/_app/$companyId/work-requests/index'
import { Route as AppCompanyIdWorkRequestsRequestIdRouteImport } from './routes/_app/$companyId/work-requests/$requestId'
import { Route as AppSettingsCompanyIdSettingsIndexRouteImport } from './routes/_appSettings/$companyId/settings/index'
import { Route as AppSettingsCompanyIdSettingsPanelRouteImport } from './routes/_appSettings/$companyId/settings/$panel'
import { Route as AppSettingsCompanyIdSettingsAssetPreferencesRouteImport } from './routes/_appSettings/$companyId/settings/asset-preferences'
import { Route as AppSettingsCompanyIdSettingsAssetsRouteImport } from './routes/_appSettings/$companyId/settings/assets'
import { Route as AppSettingsCompanyIdSettingsBugReportsRouteImport } from './routes/_appSettings/$companyId/settings/bug-reports'
import { Route as AppSettingsCompanyIdSettingsDataImportRouteImport } from './routes/_appSettings/$companyId/settings/data-import'
import { Route as AppSettingsCompanyIdSettingsGeneralRouteImport } from './routes/_appSettings/$companyId/settings/general'
import { Route as AppSettingsCompanyIdSettingsMetersRouteImport } from './routes/_appSettings/$companyId/settings/meters'
import { Route as AppSettingsCompanyIdSettingsNotificationsRouteImport } from './routes/_appSettings/$companyId/settings/notifications'
import { Route as AppSettingsCompanyIdSettingsPartsRouteImport } from './routes/_appSettings/$companyId/settings/parts'
import { Route as AppSettingsCompanyIdSettingsPeriodicMaintenancesRouteImport } from './routes/_appSettings/$companyId/settings/periodic-maintenances'
import { Route as AppSettingsCompanyIdSettingsProceduresRouteImport } from './routes/_appSettings/$companyId/settings/procedures'
import { Route as AppSettingsCompanyIdSettingsPurchaseOrdersRouteImport } from './routes/_appSettings/$companyId/settings/purchase-orders'
import { Route as AppSettingsCompanyIdSettingsSecurityRouteImport } from './routes/_appSettings/$companyId/settings/security'
import { Route as AppSettingsCompanyIdSettingsUserRouteImport } from './routes/_appSettings/$companyId/settings/user'
import { Route as AppSettingsCompanyIdSettingsUsersTeamsRouteImport } from './routes/_appSettings/$companyId/settings/users-teams'
import { Route as AppSettingsCompanyIdSettingsVendorsRouteImport } from './routes/_appSettings/$companyId/settings/vendors'
import { Route as AppSettingsCompanyIdSettingsWorkOrderTemplatesRouteImport } from './routes/_appSettings/$companyId/settings/work-order-templates'
import { Route as AppSettingsCompanyIdSettingsWorkOrdersRouteImport } from './routes/_appSettings/$companyId/settings/work-orders'
import { Route as AppSettingsCompanyIdSettingsWorkRequestsRouteImport } from './routes/_appSettings/$companyId/settings/work-requests'
import { Route as AuthenticationSsoMicrosoftCallbackRouteImport } from './routes/_authentication/sso/microsoft/callback'
import { Route as PublicShareWorkOrderCompanyIdWorkOrderIdRouteImport } from './routes/_public/share/work-order/$companyId/$workOrderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/_appSettings',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationRouteRoute = AuthenticationRouteRouteImport.update({
  id: '/_authentication',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRouteRoute = PublicRouteRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRouteRoute = SettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperUserRouteRoute = SuperUserRouteRouteImport.update({
  id: '/super-user',
  path: '/super-user',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticationForgotPasswordRoute =
  AuthenticationForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => AuthenticationRouteRoute,
  } as any)
const AuthenticationLoginRoute = AuthenticationLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthenticationRouteRoute,
} as any)
const AuthenticationLogoutRoute = AuthenticationLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthenticationRouteRoute,
} as any)
const AuthenticationResetPasswordRoute =
  AuthenticationResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => AuthenticationRouteRoute,
  } as any)
const PublicAcceptInvitationRoute = PublicAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => PublicRouteRoute,
} as any)
const PublicHandleRoute = PublicHandleRouteImport.update({
  id: '/handle',
  path: '/handle',
  getParentRoute: () => PublicRouteRoute,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsSecurityRoute = SettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsUserRoute = SettingsUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => SettingsRouteRoute,
} as any)
const SettingsUsersRoute = SettingsUsersRouteImport.update({
  id: '/settings_/users',
  path: '/settings/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SuperUserIndexRoute = SuperUserIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuperUserRouteRoute,
} as any)
const AppCompanyIdIndexRoute = AppCompanyIdIndexRouteImport.update({
  id: '/$companyId/',
  path: '/$companyId/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdAnalyticsRouteRoute =
  AppCompanyIdAnalyticsRouteRouteImport.update({
    id: '/$companyId/analytics',
    path: '/$companyId/analytics',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdHelpRoute = AppCompanyIdHelpRouteImport.update({
  id: '/$companyId/help',
  path: '/$companyId/help',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdNotAuthorizedRoute =
  AppCompanyIdNotAuthorizedRouteImport.update({
    id: '/$companyId/not-authorized',
    path: '/$companyId/not-authorized',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdPurchaseOrdersRouteRoute =
  AppCompanyIdPurchaseOrdersRouteRouteImport.update({
    id: '/$companyId/purchase-orders',
    path: '/$companyId/purchase-orders',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsRouteRoute =
  AppSettingsCompanyIdSettingsRouteRouteImport.update({
    id: '/$companyId/settings',
    path: '/$companyId/settings',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const PublicWorkRequestCompanyIdRoute =
  PublicWorkRequestCompanyIdRouteImport.update({
    id: '/work-request/$companyId',
    path: '/work-request/$companyId',
    getParentRoute: () => PublicRouteRoute,
  } as any)
const SuperUserBugReportsIndexRoute =
  SuperUserBugReportsIndexRouteImport.update({
    id: '/bug-reports/',
    path: '/bug-reports/',
    getParentRoute: () => SuperUserRouteRoute,
  } as any)
const SuperUserCompaniesIndexRoute = SuperUserCompaniesIndexRouteImport.update({
  id: '/companies/',
  path: '/companies/',
  getParentRoute: () => SuperUserRouteRoute,
} as any)
const SuperUserCompaniesCompanyIdRoute =
  SuperUserCompaniesCompanyIdRouteImport.update({
    id: '/companies/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => SuperUserRouteRoute,
  } as any)
const SuperUserHelpContentIndexRoute =
  SuperUserHelpContentIndexRouteImport.update({
    id: '/help-content/',
    path: '/help-content/',
    getParentRoute: () => SuperUserRouteRoute,
  } as any)
const SuperUserPermissionDefaultsIndexRoute =
  SuperUserPermissionDefaultsIndexRouteImport.update({
    id: '/permission-defaults/',
    path: '/permission-defaults/',
    getParentRoute: () => SuperUserRouteRoute,
  } as any)
const SuperUserUsersIndexRoute = SuperUserUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => SuperUserRouteRoute,
} as any)
const SuperUserUsersUserIdRoute = SuperUserUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => SuperUserRouteRoute,
} as any)
const AppCompanyIdAnalyticsIndexRoute =
  AppCompanyIdAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCompanyIdAnalyticsRouteRoute,
  } as any)
const AppCompanyIdAnalyticsAssetsRoute =
  AppCompanyIdAnalyticsAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AppCompanyIdAnalyticsRouteRoute,
  } as any)
const AppCompanyIdAnalyticsEmployeesRoute =
  AppCompanyIdAnalyticsEmployeesRouteImport.update({
    id: '/employees',
    path: '/employees',
    getParentRoute: () => AppCompanyIdAnalyticsRouteRoute,
  } as any)
const AppCompanyIdAnalyticsWorkOrdersRoute =
  AppCompanyIdAnalyticsWorkOrdersRouteImport.update({
    id: '/work-orders',
    path: '/work-orders',
    getParentRoute: () => AppCompanyIdAnalyticsRouteRoute,
  } as any)
const AppCompanyIdAssetsIndexRoute = AppCompanyIdAssetsIndexRouteImport.update({
  id: '/$companyId/assets/',
  path: '/$companyId/assets/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdAssetsAssetIdRoute =
  AppCompanyIdAssetsAssetIdRouteImport.update({
    id: '/$companyId/assets/$assetId',
    path: '/$companyId/assets/$assetId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdAutomationsIndexRoute =
  AppCompanyIdAutomationsIndexRouteImport.update({
    id: '/$companyId/automations/',
    path: '/$companyId/automations/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdAutomationsAutomationIdRoute =
  AppCompanyIdAutomationsAutomationIdRouteImport.update({
    id: '/$companyId/automations/$automationId',
    path: '/$companyId/automations/$automationId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdMetersIndexRoute = AppCompanyIdMetersIndexRouteImport.update({
  id: '/$companyId/meters/',
  path: '/$companyId/meters/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdMetersMeterIdRoute =
  AppCompanyIdMetersMeterIdRouteImport.update({
    id: '/$companyId/meters/$meterId',
    path: '/$companyId/meters/$meterId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdPartsIndexRoute = AppCompanyIdPartsIndexRouteImport.update({
  id: '/$companyId/parts/',
  path: '/$companyId/parts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdPartsPartIdRoute = AppCompanyIdPartsPartIdRouteImport.update({
  id: '/$companyId/parts/$partId',
  path: '/$companyId/parts/$partId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCompanyIdPeriodicMaintenancesIndexRoute =
  AppCompanyIdPeriodicMaintenancesIndexRouteImport.update({
    id: '/$companyId/periodic-maintenances/',
    path: '/$companyId/periodic-maintenances/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute =
  AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRouteImport.update({
    id: '/$companyId/periodic-maintenances/$periodicMaintenanceId',
    path: '/$companyId/periodic-maintenances/$periodicMaintenanceId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdProceduresIndexRoute =
  AppCompanyIdProceduresIndexRouteImport.update({
    id: '/$companyId/procedures/',
    path: '/$companyId/procedures/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdProceduresProcedureIdRoute =
  AppCompanyIdProceduresProcedureIdRouteImport.update({
    id: '/$companyId/procedures/$procedureId',
    path: '/$companyId/procedures/$procedureId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdPurchaseOrdersIndexRoute =
  AppCompanyIdPurchaseOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppCompanyIdPurchaseOrdersRouteRoute,
  } as any)
const AppCompanyIdPurchaseOrdersOrderIdRoute =
  AppCompanyIdPurchaseOrdersOrderIdRouteImport.update({
    id: '/$orderId',
    path: '/$orderId',
    getParentRoute: () => AppCompanyIdPurchaseOrdersRouteRoute,
  } as any)
const AppCompanyIdVendorsIndexRoute =
  AppCompanyIdVendorsIndexRouteImport.update({
    id: '/$companyId/vendors/',
    path: '/$companyId/vendors/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdVendorsVendorIdRoute =
  AppCompanyIdVendorsVendorIdRouteImport.update({
    id: '/$companyId/vendors/$vendorId',
    path: '/$companyId/vendors/$vendorId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkOrderTemplatesIndexRoute =
  AppCompanyIdWorkOrderTemplatesIndexRouteImport.update({
    id: '/$companyId/work-order-templates/',
    path: '/$companyId/work-order-templates/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkOrderTemplatesTemplateIdRoute =
  AppCompanyIdWorkOrderTemplatesTemplateIdRouteImport.update({
    id: '/$companyId/work-order-templates/$templateId',
    path: '/$companyId/work-order-templates/$templateId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkOrdersIndexRoute =
  AppCompanyIdWorkOrdersIndexRouteImport.update({
    id: '/$companyId/work-orders/',
    path: '/$companyId/work-orders/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkOrdersWorkOrderIdRoute =
  AppCompanyIdWorkOrdersWorkOrderIdRouteImport.update({
    id: '/$companyId/work-orders/$workOrderId',
    path: '/$companyId/work-orders/$workOrderId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkRequestsIndexRoute =
  AppCompanyIdWorkRequestsIndexRouteImport.update({
    id: '/$companyId/work-requests/',
    path: '/$companyId/work-requests/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppCompanyIdWorkRequestsRequestIdRoute =
  AppCompanyIdWorkRequestsRequestIdRouteImport.update({
    id: '/$companyId/work-requests/$requestId',
    path: '/$companyId/work-requests/$requestId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsIndexRoute =
  AppSettingsCompanyIdSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsPanelRoute =
  AppSettingsCompanyIdSettingsPanelRouteImport.update({
    id: '/$panel',
    path: '/$panel',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsAssetPreferencesRoute =
  AppSettingsCompanyIdSettingsAssetPreferencesRouteImport.update({
    id: '/asset-preferences',
    path: '/asset-preferences',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsAssetsRoute =
  AppSettingsCompanyIdSettingsAssetsRouteImport.update({
    id: '/assets',
    path: '/assets',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsBugReportsRoute =
  AppSettingsCompanyIdSettingsBugReportsRouteImport.update({
    id: '/bug-reports',
    path: '/bug-reports',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsDataImportRoute =
  AppSettingsCompanyIdSettingsDataImportRouteImport.update({
    id: '/data-import',
    path: '/data-import',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsGeneralRoute =
  AppSettingsCompanyIdSettingsGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsMetersRoute =
  AppSettingsCompanyIdSettingsMetersRouteImport.update({
    id: '/meters',
    path: '/meters',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsNotificationsRoute =
  AppSettingsCompanyIdSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsPartsRoute =
  AppSettingsCompanyIdSettingsPartsRouteImport.update({
    id: '/parts',
    path: '/parts',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute =
  AppSettingsCompanyIdSettingsPeriodicMaintenancesRouteImport.update({
    id: '/periodic-maintenances',
    path: '/periodic-maintenances',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsProceduresRoute =
  AppSettingsCompanyIdSettingsProceduresRouteImport.update({
    id: '/procedures',
    path: '/procedures',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsPurchaseOrdersRoute =
  AppSettingsCompanyIdSettingsPurchaseOrdersRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsSecurityRoute =
  AppSettingsCompanyIdSettingsSecurityRouteImport.update({
    id: '/security',
    path: '/security',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsUserRoute =
  AppSettingsCompanyIdSettingsUserRouteImport.update({
    id: '/user',
    path: '/user',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsUsersTeamsRoute =
  AppSettingsCompanyIdSettingsUsersTeamsRouteImport.update({
    id: '/users-teams',
    path: '/users-teams',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsVendorsRoute =
  AppSettingsCompanyIdSettingsVendorsRouteImport.update({
    id: '/vendors',
    path: '/vendors',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute =
  AppSettingsCompanyIdSettingsWorkOrderTemplatesRouteImport.update({
    id: '/work-order-templates',
    path: '/work-order-templates',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsWorkOrdersRoute =
  AppSettingsCompanyIdSettingsWorkOrdersRouteImport.update({
    id: '/work-orders',
    path: '/work-orders',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AppSettingsCompanyIdSettingsWorkRequestsRoute =
  AppSettingsCompanyIdSettingsWorkRequestsRouteImport.update({
    id: '/work-requests',
    path: '/work-requests',
    getParentRoute: () => AppSettingsCompanyIdSettingsRouteRoute,
  } as any)
const AuthenticationSsoMicrosoftCallbackRoute =
  AuthenticationSsoMicrosoftCallbackRouteImport.update({
    id: '/sso/microsoft/callback',
    path: '/sso/microsoft/callback',
    getParentRoute: () => AuthenticationRouteRoute,
  } as any)
const PublicShareWorkOrderCompanyIdWorkOrderIdRoute =
  PublicShareWorkOrderCompanyIdWorkOrderIdRouteImport.update({
    id: '/share/work-order/$companyId/$workOrderId',
    path: '/share/work-order/$companyId/$workOrderId',
    getParentRoute: () => PublicRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/settings': typeof SettingsRouteRouteWithChildren
  '/super-user': typeof SuperUserRouteRouteWithChildren
  '/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/login': typeof AuthenticationLoginRoute
  '/logout': typeof AuthenticationLogoutRoute
  '/reset-password': typeof AuthenticationResetPasswordRoute
  '/accept-invitation': typeof PublicAcceptInvitationRoute
  '/handle': typeof PublicHandleRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/user': typeof SettingsUserRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings/': typeof SettingsIndexRoute
  '/super-user/': typeof SuperUserIndexRoute
  '/$companyId/analytics': typeof AppCompanyIdAnalyticsRouteRouteWithChildren
  '/$companyId/purchase-orders': typeof AppCompanyIdPurchaseOrdersRouteRouteWithChildren
  '/$companyId/settings': typeof AppSettingsCompanyIdSettingsRouteRouteWithChildren
  '/$companyId/help': typeof AppCompanyIdHelpRoute
  '/$companyId/not-authorized': typeof AppCompanyIdNotAuthorizedRoute
  '/work-request/$companyId': typeof PublicWorkRequestCompanyIdRoute
  '/super-user/companies/$companyId': typeof SuperUserCompaniesCompanyIdRoute
  '/super-user/users/$userId': typeof SuperUserUsersUserIdRoute
  '/$companyId/': typeof AppCompanyIdIndexRoute
  '/super-user/bug-reports/': typeof SuperUserBugReportsIndexRoute
  '/super-user/companies/': typeof SuperUserCompaniesIndexRoute
  '/super-user/help-content/': typeof SuperUserHelpContentIndexRoute
  '/super-user/permission-defaults/': typeof SuperUserPermissionDefaultsIndexRoute
  '/super-user/users/': typeof SuperUserUsersIndexRoute
  '/$companyId/analytics/assets': typeof AppCompanyIdAnalyticsAssetsRoute
  '/$companyId/analytics/employees': typeof AppCompanyIdAnalyticsEmployeesRoute
  '/$companyId/analytics/work-orders': typeof AppCompanyIdAnalyticsWorkOrdersRoute
  '/$companyId/assets/$assetId': typeof AppCompanyIdAssetsAssetIdRoute
  '/$companyId/automations/$automationId': typeof AppCompanyIdAutomationsAutomationIdRoute
  '/$companyId/meters/$meterId': typeof AppCompanyIdMetersMeterIdRoute
  '/$companyId/parts/$partId': typeof AppCompanyIdPartsPartIdRoute
  '/$companyId/periodic-maintenances/$periodicMaintenanceId': typeof AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute
  '/$companyId/procedures/$procedureId': typeof AppCompanyIdProceduresProcedureIdRoute
  '/$companyId/purchase-orders/$orderId': typeof AppCompanyIdPurchaseOrdersOrderIdRoute
  '/$companyId/vendors/$vendorId': typeof AppCompanyIdVendorsVendorIdRoute
  '/$companyId/work-order-templates/$templateId': typeof AppCompanyIdWorkOrderTemplatesTemplateIdRoute
  '/$companyId/work-orders/$workOrderId': typeof AppCompanyIdWorkOrdersWorkOrderIdRoute
  '/$companyId/work-requests/$requestId': typeof AppCompanyIdWorkRequestsRequestIdRoute
  '/$companyId/settings/$panel': typeof AppSettingsCompanyIdSettingsPanelRoute
  '/$companyId/settings/asset-preferences': typeof AppSettingsCompanyIdSettingsAssetPreferencesRoute
  '/$companyId/settings/assets': typeof AppSettingsCompanyIdSettingsAssetsRoute
  '/$companyId/settings/bug-reports': typeof AppSettingsCompanyIdSettingsBugReportsRoute
  '/$companyId/settings/data-import': typeof AppSettingsCompanyIdSettingsDataImportRoute
  '/$companyId/settings/general': typeof AppSettingsCompanyIdSettingsGeneralRoute
  '/$companyId/settings/meters': typeof AppSettingsCompanyIdSettingsMetersRoute
  '/$companyId/settings/notifications': typeof AppSettingsCompanyIdSettingsNotificationsRoute
  '/$companyId/settings/parts': typeof AppSettingsCompanyIdSettingsPartsRoute
  '/$companyId/settings/periodic-maintenances': typeof AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute
  '/$companyId/settings/procedures': typeof AppSettingsCompanyIdSettingsProceduresRoute
  '/$companyId/settings/purchase-orders': typeof AppSettingsCompanyIdSettingsPurchaseOrdersRoute
  '/$companyId/settings/security': typeof AppSettingsCompanyIdSettingsSecurityRoute
  '/$companyId/settings/user': typeof AppSettingsCompanyIdSettingsUserRoute
  '/$companyId/settings/users-teams': typeof AppSettingsCompanyIdSettingsUsersTeamsRoute
  '/$companyId/settings/vendors': typeof AppSettingsCompanyIdSettingsVendorsRoute
  '/$companyId/settings/work-order-templates': typeof AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute
  '/$companyId/settings/work-orders': typeof AppSettingsCompanyIdSettingsWorkOrdersRoute
  '/$companyId/settings/work-requests': typeof AppSettingsCompanyIdSettingsWorkRequestsRoute
  '/sso/microsoft/callback': typeof AuthenticationSsoMicrosoftCallbackRoute
  '/$companyId/analytics/': typeof AppCompanyIdAnalyticsIndexRoute
  '/$companyId/assets/': typeof AppCompanyIdAssetsIndexRoute
  '/$companyId/automations/': typeof AppCompanyIdAutomationsIndexRoute
  '/$companyId/meters/': typeof AppCompanyIdMetersIndexRoute
  '/$companyId/parts/': typeof AppCompanyIdPartsIndexRoute
  '/$companyId/periodic-maintenances/': typeof AppCompanyIdPeriodicMaintenancesIndexRoute
  '/$companyId/procedures/': typeof AppCompanyIdProceduresIndexRoute
  '/$companyId/purchase-orders/': typeof AppCompanyIdPurchaseOrdersIndexRoute
  '/$companyId/vendors/': typeof AppCompanyIdVendorsIndexRoute
  '/$companyId/work-order-templates/': typeof AppCompanyIdWorkOrderTemplatesIndexRoute
  '/$companyId/work-orders/': typeof AppCompanyIdWorkOrdersIndexRoute
  '/$companyId/work-requests/': typeof AppCompanyIdWorkRequestsIndexRoute
  '/$companyId/settings/': typeof AppSettingsCompanyIdSettingsIndexRoute
  '/share/work-order/$companyId/$workOrderId': typeof PublicShareWorkOrderCompanyIdWorkOrderIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/login': typeof AuthenticationLoginRoute
  '/logout': typeof AuthenticationLogoutRoute
  '/reset-password': typeof AuthenticationResetPasswordRoute
  '/accept-invitation': typeof PublicAcceptInvitationRoute
  '/handle': typeof PublicHandleRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/user': typeof SettingsUserRoute
  '/settings/users': typeof SettingsUsersRoute
  '/settings': typeof SettingsIndexRoute
  '/super-user': typeof SuperUserIndexRoute
  '/$companyId/help': typeof AppCompanyIdHelpRoute
  '/$companyId/not-authorized': typeof AppCompanyIdNotAuthorizedRoute
  '/work-request/$companyId': typeof PublicWorkRequestCompanyIdRoute
  '/super-user/companies/$companyId': typeof SuperUserCompaniesCompanyIdRoute
  '/super-user/users/$userId': typeof SuperUserUsersUserIdRoute
  '/$companyId': typeof AppCompanyIdIndexRoute
  '/super-user/bug-reports': typeof SuperUserBugReportsIndexRoute
  '/super-user/companies': typeof SuperUserCompaniesIndexRoute
  '/super-user/help-content': typeof SuperUserHelpContentIndexRoute
  '/super-user/permission-defaults': typeof SuperUserPermissionDefaultsIndexRoute
  '/super-user/users': typeof SuperUserUsersIndexRoute
  '/$companyId/analytics/assets': typeof AppCompanyIdAnalyticsAssetsRoute
  '/$companyId/analytics/employees': typeof AppCompanyIdAnalyticsEmployeesRoute
  '/$companyId/analytics/work-orders': typeof AppCompanyIdAnalyticsWorkOrdersRoute
  '/$companyId/assets/$assetId': typeof AppCompanyIdAssetsAssetIdRoute
  '/$companyId/automations/$automationId': typeof AppCompanyIdAutomationsAutomationIdRoute
  '/$companyId/meters/$meterId': typeof AppCompanyIdMetersMeterIdRoute
  '/$companyId/parts/$partId': typeof AppCompanyIdPartsPartIdRoute
  '/$companyId/periodic-maintenances/$periodicMaintenanceId': typeof AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute
  '/$companyId/procedures/$procedureId': typeof AppCompanyIdProceduresProcedureIdRoute
  '/$companyId/purchase-orders/$orderId': typeof AppCompanyIdPurchaseOrdersOrderIdRoute
  '/$companyId/vendors/$vendorId': typeof AppCompanyIdVendorsVendorIdRoute
  '/$companyId/work-order-templates/$templateId': typeof AppCompanyIdWorkOrderTemplatesTemplateIdRoute
  '/$companyId/work-orders/$workOrderId': typeof AppCompanyIdWorkOrdersWorkOrderIdRoute
  '/$companyId/work-requests/$requestId': typeof AppCompanyIdWorkRequestsRequestIdRoute
  '/$companyId/settings/$panel': typeof AppSettingsCompanyIdSettingsPanelRoute
  '/$companyId/settings/asset-preferences': typeof AppSettingsCompanyIdSettingsAssetPreferencesRoute
  '/$companyId/settings/assets': typeof AppSettingsCompanyIdSettingsAssetsRoute
  '/$companyId/settings/bug-reports': typeof AppSettingsCompanyIdSettingsBugReportsRoute
  '/$companyId/settings/data-import': typeof AppSettingsCompanyIdSettingsDataImportRoute
  '/$companyId/settings/general': typeof AppSettingsCompanyIdSettingsGeneralRoute
  '/$companyId/settings/meters': typeof AppSettingsCompanyIdSettingsMetersRoute
  '/$companyId/settings/notifications': typeof AppSettingsCompanyIdSettingsNotificationsRoute
  '/$companyId/settings/parts': typeof AppSettingsCompanyIdSettingsPartsRoute
  '/$companyId/settings/periodic-maintenances': typeof AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute
  '/$companyId/settings/procedures': typeof AppSettingsCompanyIdSettingsProceduresRoute
  '/$companyId/settings/purchase-orders': typeof AppSettingsCompanyIdSettingsPurchaseOrdersRoute
  '/$companyId/settings/security': typeof AppSettingsCompanyIdSettingsSecurityRoute
  '/$companyId/settings/user': typeof AppSettingsCompanyIdSettingsUserRoute
  '/$companyId/settings/users-teams': typeof AppSettingsCompanyIdSettingsUsersTeamsRoute
  '/$companyId/settings/vendors': typeof AppSettingsCompanyIdSettingsVendorsRoute
  '/$companyId/settings/work-order-templates': typeof AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute
  '/$companyId/settings/work-orders': typeof AppSettingsCompanyIdSettingsWorkOrdersRoute
  '/$companyId/settings/work-requests': typeof AppSettingsCompanyIdSettingsWorkRequestsRoute
  '/sso/microsoft/callback': typeof AuthenticationSsoMicrosoftCallbackRoute
  '/$companyId/analytics': typeof AppCompanyIdAnalyticsIndexRoute
  '/$companyId/assets': typeof AppCompanyIdAssetsIndexRoute
  '/$companyId/automations': typeof AppCompanyIdAutomationsIndexRoute
  '/$companyId/meters': typeof AppCompanyIdMetersIndexRoute
  '/$companyId/parts': typeof AppCompanyIdPartsIndexRoute
  '/$companyId/periodic-maintenances': typeof AppCompanyIdPeriodicMaintenancesIndexRoute
  '/$companyId/procedures': typeof AppCompanyIdProceduresIndexRoute
  '/$companyId/purchase-orders': typeof AppCompanyIdPurchaseOrdersIndexRoute
  '/$companyId/vendors': typeof AppCompanyIdVendorsIndexRoute
  '/$companyId/work-order-templates': typeof AppCompanyIdWorkOrderTemplatesIndexRoute
  '/$companyId/work-orders': typeof AppCompanyIdWorkOrdersIndexRoute
  '/$companyId/work-requests': typeof AppCompanyIdWorkRequestsIndexRoute
  '/$companyId/settings': typeof AppSettingsCompanyIdSettingsIndexRoute
  '/share/work-order/$companyId/$workOrderId': typeof PublicShareWorkOrderCompanyIdWorkOrderIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/_appSettings': typeof AppSettingsRouteRouteWithChildren
  '/_authentication': typeof AuthenticationRouteRouteWithChildren
  '/_public': typeof PublicRouteRouteWithChildren
  '/settings': typeof SettingsRouteRouteWithChildren
  '/super-user': typeof SuperUserRouteRouteWithChildren
  '/_authentication/forgot-password': typeof AuthenticationForgotPasswordRoute
  '/_authentication/login': typeof AuthenticationLoginRoute
  '/_authentication/logout': typeof AuthenticationLogoutRoute
  '/_authentication/reset-password': typeof AuthenticationResetPasswordRoute
  '/_public/accept-invitation': typeof PublicAcceptInvitationRoute
  '/_public/handle': typeof PublicHandleRoute
  '/settings/security': typeof SettingsSecurityRoute
  '/settings/user': typeof SettingsUserRoute
  '/settings_/users': typeof SettingsUsersRoute
  '/settings/': typeof SettingsIndexRoute
  '/super-user/': typeof SuperUserIndexRoute
  '/_app/$companyId/analytics': typeof AppCompanyIdAnalyticsRouteRouteWithChildren
  '/_app/$companyId/purchase-orders': typeof AppCompanyIdPurchaseOrdersRouteRouteWithChildren
  '/_appSettings/$companyId/settings': typeof AppSettingsCompanyIdSettingsRouteRouteWithChildren
  '/_app/$companyId/help': typeof AppCompanyIdHelpRoute
  '/_app/$companyId/not-authorized': typeof AppCompanyIdNotAuthorizedRoute
  '/_public/work-request/$companyId': typeof PublicWorkRequestCompanyIdRoute
  '/super-user/companies/$companyId': typeof SuperUserCompaniesCompanyIdRoute
  '/super-user/users/$userId': typeof SuperUserUsersUserIdRoute
  '/_app/$companyId/': typeof AppCompanyIdIndexRoute
  '/super-user/bug-reports/': typeof SuperUserBugReportsIndexRoute
  '/super-user/companies/': typeof SuperUserCompaniesIndexRoute
  '/super-user/help-content/': typeof SuperUserHelpContentIndexRoute
  '/super-user/permission-defaults/': typeof SuperUserPermissionDefaultsIndexRoute
  '/super-user/users/': typeof SuperUserUsersIndexRoute
  '/_app/$companyId/analytics/assets': typeof AppCompanyIdAnalyticsAssetsRoute
  '/_app/$companyId/analytics/employees': typeof AppCompanyIdAnalyticsEmployeesRoute
  '/_app/$companyId/analytics/work-orders': typeof AppCompanyIdAnalyticsWorkOrdersRoute
  '/_app/$companyId/assets/$assetId': typeof AppCompanyIdAssetsAssetIdRoute
  '/_app/$companyId/automations/$automationId': typeof AppCompanyIdAutomationsAutomationIdRoute
  '/_app/$companyId/meters/$meterId': typeof AppCompanyIdMetersMeterIdRoute
  '/_app/$companyId/parts/$partId': typeof AppCompanyIdPartsPartIdRoute
  '/_app/$companyId/periodic-maintenances/$periodicMaintenanceId': typeof AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute
  '/_app/$companyId/procedures/$procedureId': typeof AppCompanyIdProceduresProcedureIdRoute
  '/_app/$companyId/purchase-orders/$orderId': typeof AppCompanyIdPurchaseOrdersOrderIdRoute
  '/_app/$companyId/vendors/$vendorId': typeof AppCompanyIdVendorsVendorIdRoute
  '/_app/$companyId/work-order-templates/$templateId': typeof AppCompanyIdWorkOrderTemplatesTemplateIdRoute
  '/_app/$companyId/work-orders/$workOrderId': typeof AppCompanyIdWorkOrdersWorkOrderIdRoute
  '/_app/$companyId/work-requests/$requestId': typeof AppCompanyIdWorkRequestsRequestIdRoute
  '/_appSettings/$companyId/settings/$panel': typeof AppSettingsCompanyIdSettingsPanelRoute
  '/_appSettings/$companyId/settings/asset-preferences': typeof AppSettingsCompanyIdSettingsAssetPreferencesRoute
  '/_appSettings/$companyId/settings/assets': typeof AppSettingsCompanyIdSettingsAssetsRoute
  '/_appSettings/$companyId/settings/bug-reports': typeof AppSettingsCompanyIdSettingsBugReportsRoute
  '/_appSettings/$companyId/settings/data-import': typeof AppSettingsCompanyIdSettingsDataImportRoute
  '/_appSettings/$companyId/settings/general': typeof AppSettingsCompanyIdSettingsGeneralRoute
  '/_appSettings/$companyId/settings/meters': typeof AppSettingsCompanyIdSettingsMetersRoute
  '/_appSettings/$companyId/settings/notifications': typeof AppSettingsCompanyIdSettingsNotificationsRoute
  '/_appSettings/$companyId/settings/parts': typeof AppSettingsCompanyIdSettingsPartsRoute
  '/_appSettings/$companyId/settings/periodic-maintenances': typeof AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute
  '/_appSettings/$companyId/settings/procedures': typeof AppSettingsCompanyIdSettingsProceduresRoute
  '/_appSettings/$companyId/settings/purchase-orders': typeof AppSettingsCompanyIdSettingsPurchaseOrdersRoute
  '/_appSettings/$companyId/settings/security': typeof AppSettingsCompanyIdSettingsSecurityRoute
  '/_appSettings/$companyId/settings/user': typeof AppSettingsCompanyIdSettingsUserRoute
  '/_appSettings/$companyId/settings/users-teams': typeof AppSettingsCompanyIdSettingsUsersTeamsRoute
  '/_appSettings/$companyId/settings/vendors': typeof AppSettingsCompanyIdSettingsVendorsRoute
  '/_appSettings/$companyId/settings/work-order-templates': typeof AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute
  '/_appSettings/$companyId/settings/work-orders': typeof AppSettingsCompanyIdSettingsWorkOrdersRoute
  '/_appSettings/$companyId/settings/work-requests': typeof AppSettingsCompanyIdSettingsWorkRequestsRoute
  '/_authentication/sso/microsoft/callback': typeof AuthenticationSsoMicrosoftCallbackRoute
  '/_app/$companyId/analytics/': typeof AppCompanyIdAnalyticsIndexRoute
  '/_app/$companyId/assets/': typeof AppCompanyIdAssetsIndexRoute
  '/_app/$companyId/automations/': typeof AppCompanyIdAutomationsIndexRoute
  '/_app/$companyId/meters/': typeof AppCompanyIdMetersIndexRoute
  '/_app/$companyId/parts/': typeof AppCompanyIdPartsIndexRoute
  '/_app/$companyId/periodic-maintenances/': typeof AppCompanyIdPeriodicMaintenancesIndexRoute
  '/_app/$companyId/procedures/': typeof AppCompanyIdProceduresIndexRoute
  '/_app/$companyId/purchase-orders/': typeof AppCompanyIdPurchaseOrdersIndexRoute
  '/_app/$companyId/vendors/': typeof AppCompanyIdVendorsIndexRoute
  '/_app/$companyId/work-order-templates/': typeof AppCompanyIdWorkOrderTemplatesIndexRoute
  '/_app/$companyId/work-orders/': typeof AppCompanyIdWorkOrdersIndexRoute
  '/_app/$companyId/work-requests/': typeof AppCompanyIdWorkRequestsIndexRoute
  '/_appSettings/$companyId/settings/': typeof AppSettingsCompanyIdSettingsIndexRoute
  '/_public/share/work-order/$companyId/$workOrderId': typeof PublicShareWorkOrderCompanyIdWorkOrderIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/settings'
    | '/super-user'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/accept-invitation'
    | '/handle'
    | '/settings/security'
    | '/settings/user'
    | '/settings/users'
    | '/settings/'
    | '/super-user/'
    | '/$companyId/analytics'
    | '/$companyId/purchase-orders'
    | '/$companyId/settings'
    | '/$companyId/help'
    | '/$companyId/not-authorized'
    | '/work-request/$companyId'
    | '/super-user/companies/$companyId'
    | '/super-user/users/$userId'
    | '/$companyId/'
    | '/super-user/bug-reports/'
    | '/super-user/companies/'
    | '/super-user/help-content/'
    | '/super-user/permission-defaults/'
    | '/super-user/users/'
    | '/$companyId/analytics/assets'
    | '/$companyId/analytics/employees'
    | '/$companyId/analytics/work-orders'
    | '/$companyId/assets/$assetId'
    | '/$companyId/automations/$automationId'
    | '/$companyId/meters/$meterId'
    | '/$companyId/parts/$partId'
    | '/$companyId/periodic-maintenances/$periodicMaintenanceId'
    | '/$companyId/procedures/$procedureId'
    | '/$companyId/purchase-orders/$orderId'
    | '/$companyId/vendors/$vendorId'
    | '/$companyId/work-order-templates/$templateId'
    | '/$companyId/work-orders/$workOrderId'
    | '/$companyId/work-requests/$requestId'
    | '/$companyId/settings/$panel'
    | '/$companyId/settings/asset-preferences'
    | '/$companyId/settings/assets'
    | '/$companyId/settings/bug-reports'
    | '/$companyId/settings/data-import'
    | '/$companyId/settings/general'
    | '/$companyId/settings/meters'
    | '/$companyId/settings/notifications'
    | '/$companyId/settings/parts'
    | '/$companyId/settings/periodic-maintenances'
    | '/$companyId/settings/procedures'
    | '/$companyId/settings/purchase-orders'
    | '/$companyId/settings/security'
    | '/$companyId/settings/user'
    | '/$companyId/settings/users-teams'
    | '/$companyId/settings/vendors'
    | '/$companyId/settings/work-order-templates'
    | '/$companyId/settings/work-orders'
    | '/$companyId/settings/work-requests'
    | '/sso/microsoft/callback'
    | '/$companyId/analytics/'
    | '/$companyId/assets/'
    | '/$companyId/automations/'
    | '/$companyId/meters/'
    | '/$companyId/parts/'
    | '/$companyId/periodic-maintenances/'
    | '/$companyId/procedures/'
    | '/$companyId/purchase-orders/'
    | '/$companyId/vendors/'
    | '/$companyId/work-order-templates/'
    | '/$companyId/work-orders/'
    | '/$companyId/work-requests/'
    | '/$companyId/settings/'
    | '/share/work-order/$companyId/$workOrderId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/accept-invitation'
    | '/handle'
    | '/settings/security'
    | '/settings/user'
    | '/settings/users'
    | '/settings'
    | '/super-user'
    | '/$companyId/help'
    | '/$companyId/not-authorized'
    | '/work-request/$companyId'
    | '/super-user/companies/$companyId'
    | '/super-user/users/$userId'
    | '/$companyId'
    | '/super-user/bug-reports'
    | '/super-user/companies'
    | '/super-user/help-content'
    | '/super-user/permission-defaults'
    | '/super-user/users'
    | '/$companyId/analytics/assets'
    | '/$companyId/analytics/employees'
    | '/$companyId/analytics/work-orders'
    | '/$companyId/assets/$assetId'
    | '/$companyId/automations/$automationId'
    | '/$companyId/meters/$meterId'
    | '/$companyId/parts/$partId'
    | '/$companyId/periodic-maintenances/$periodicMaintenanceId'
    | '/$companyId/procedures/$procedureId'
    | '/$companyId/purchase-orders/$orderId'
    | '/$companyId/vendors/$vendorId'
    | '/$companyId/work-order-templates/$templateId'
    | '/$companyId/work-orders/$workOrderId'
    | '/$companyId/work-requests/$requestId'
    | '/$companyId/settings/$panel'
    | '/$companyId/settings/asset-preferences'
    | '/$companyId/settings/assets'
    | '/$companyId/settings/bug-reports'
    | '/$companyId/settings/data-import'
    | '/$companyId/settings/general'
    | '/$companyId/settings/meters'
    | '/$companyId/settings/notifications'
    | '/$companyId/settings/parts'
    | '/$companyId/settings/periodic-maintenances'
    | '/$companyId/settings/procedures'
    | '/$companyId/settings/purchase-orders'
    | '/$companyId/settings/security'
    | '/$companyId/settings/user'
    | '/$companyId/settings/users-teams'
    | '/$companyId/settings/vendors'
    | '/$companyId/settings/work-order-templates'
    | '/$companyId/settings/work-orders'
    | '/$companyId/settings/work-requests'
    | '/sso/microsoft/callback'
    | '/$companyId/analytics'
    | '/$companyId/assets'
    | '/$companyId/automations'
    | '/$companyId/meters'
    | '/$companyId/parts'
    | '/$companyId/periodic-maintenances'
    | '/$companyId/procedures'
    | '/$companyId/purchase-orders'
    | '/$companyId/vendors'
    | '/$companyId/work-order-templates'
    | '/$companyId/work-orders'
    | '/$companyId/work-requests'
    | '/$companyId/settings'
    | '/share/work-order/$companyId/$workOrderId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_appSettings'
    | '/_authentication'
    | '/_public'
    | '/settings'
    | '/super-user'
    | '/_authentication/forgot-password'
    | '/_authentication/login'
    | '/_authentication/logout'
    | '/_authentication/reset-password'
    | '/_public/accept-invitation'
    | '/_public/handle'
    | '/settings/security'
    | '/settings/user'
    | '/settings_/users'
    | '/settings/'
    | '/super-user/'
    | '/_app/$companyId/analytics'
    | '/_app/$companyId/purchase-orders'
    | '/_appSettings/$companyId/settings'
    | '/_app/$companyId/help'
    | '/_app/$companyId/not-authorized'
    | '/_public/work-request/$companyId'
    | '/super-user/companies/$companyId'
    | '/super-user/users/$userId'
    | '/_app/$companyId/'
    | '/super-user/bug-reports/'
    | '/super-user/companies/'
    | '/super-user/help-content/'
    | '/super-user/permission-defaults/'
    | '/super-user/users/'
    | '/_app/$companyId/analytics/assets'
    | '/_app/$companyId/analytics/employees'
    | '/_app/$companyId/analytics/work-orders'
    | '/_app/$companyId/assets/$assetId'
    | '/_app/$companyId/automations/$automationId'
    | '/_app/$companyId/meters/$meterId'
    | '/_app/$companyId/parts/$partId'
    | '/_app/$companyId/periodic-maintenances/$periodicMaintenanceId'
    | '/_app/$companyId/procedures/$procedureId'
    | '/_app/$companyId/purchase-orders/$orderId'
    | '/_app/$companyId/vendors/$vendorId'
    | '/_app/$companyId/work-order-templates/$templateId'
    | '/_app/$companyId/work-orders/$workOrderId'
    | '/_app/$companyId/work-requests/$requestId'
    | '/_appSettings/$companyId/settings/$panel'
    | '/_appSettings/$companyId/settings/asset-preferences'
    | '/_appSettings/$companyId/settings/assets'
    | '/_appSettings/$companyId/settings/bug-reports'
    | '/_appSettings/$companyId/settings/data-import'
    | '/_appSettings/$companyId/settings/general'
    | '/_appSettings/$companyId/settings/meters'
    | '/_appSettings/$companyId/settings/notifications'
    | '/_appSettings/$companyId/settings/parts'
    | '/_appSettings/$companyId/settings/periodic-maintenances'
    | '/_appSettings/$companyId/settings/procedures'
    | '/_appSettings/$companyId/settings/purchase-orders'
    | '/_appSettings/$companyId/settings/security'
    | '/_appSettings/$companyId/settings/user'
    | '/_appSettings/$companyId/settings/users-teams'
    | '/_appSettings/$companyId/settings/vendors'
    | '/_appSettings/$companyId/settings/work-order-templates'
    | '/_appSettings/$companyId/settings/work-orders'
    | '/_appSettings/$companyId/settings/work-requests'
    | '/_authentication/sso/microsoft/callback'
    | '/_app/$companyId/analytics/'
    | '/_app/$companyId/assets/'
    | '/_app/$companyId/automations/'
    | '/_app/$companyId/meters/'
    | '/_app/$companyId/parts/'
    | '/_app/$companyId/periodic-maintenances/'
    | '/_app/$companyId/procedures/'
    | '/_app/$companyId/purchase-orders/'
    | '/_app/$companyId/vendors/'
    | '/_app/$companyId/work-order-templates/'
    | '/_app/$companyId/work-orders/'
    | '/_app/$companyId/work-requests/'
    | '/_appSettings/$companyId/settings/'
    | '/_public/share/work-order/$companyId/$workOrderId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AuthenticationRouteRoute: typeof AuthenticationRouteRouteWithChildren
  PublicRouteRoute: typeof PublicRouteRouteWithChildren
  SettingsRouteRoute: typeof SettingsRouteRouteWithChildren
  SuperUserRouteRoute: typeof SuperUserRouteRouteWithChildren
  SettingsUsersRoute: typeof SettingsUsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_appSettings': {
      id: '/_appSettings'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authentication': {
      id: '/_authentication'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticationRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/super-user': {
      id: '/super-user'
      path: '/super-user'
      fullPath: '/super-user'
      preLoaderRoute: typeof SuperUserRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authentication/forgot-password': {
      id: '/_authentication/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthenticationForgotPasswordRouteImport
      parentRoute: typeof AuthenticationRouteRoute
    }
    '/_authentication/login': {
      id: '/_authentication/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthenticationLoginRouteImport
      parentRoute: typeof AuthenticationRouteRoute
    }
    '/_authentication/logout': {
      id: '/_authentication/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthenticationLogoutRouteImport
      parentRoute: typeof AuthenticationRouteRoute
    }
    '/_authentication/reset-password': {
      id: '/_authentication/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthenticationResetPasswordRouteImport
      parentRoute: typeof AuthenticationRouteRoute
    }
    '/_public/accept-invitation': {
      id: '/_public/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof PublicAcceptInvitationRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/_public/handle': {
      id: '/_public/handle'
      path: '/handle'
      fullPath: '/handle'
      preLoaderRoute: typeof PublicHandleRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/security': {
      id: '/settings/security'
      path: '/security'
      fullPath: '/settings/security'
      preLoaderRoute: typeof SettingsSecurityRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings/user': {
      id: '/settings/user'
      path: '/user'
      fullPath: '/settings/user'
      preLoaderRoute: typeof SettingsUserRouteImport
      parentRoute: typeof SettingsRouteRoute
    }
    '/settings_/users': {
      id: '/settings_/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof SettingsUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/super-user/': {
      id: '/super-user/'
      path: '/'
      fullPath: '/super-user/'
      preLoaderRoute: typeof SuperUserIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/_app/$companyId/': {
      id: '/_app/$companyId/'
      path: '/$companyId'
      fullPath: '/$companyId/'
      preLoaderRoute: typeof AppCompanyIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/analytics': {
      id: '/_app/$companyId/analytics'
      path: '/$companyId/analytics'
      fullPath: '/$companyId/analytics'
      preLoaderRoute: typeof AppCompanyIdAnalyticsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/help': {
      id: '/_app/$companyId/help'
      path: '/$companyId/help'
      fullPath: '/$companyId/help'
      preLoaderRoute: typeof AppCompanyIdHelpRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/not-authorized': {
      id: '/_app/$companyId/not-authorized'
      path: '/$companyId/not-authorized'
      fullPath: '/$companyId/not-authorized'
      preLoaderRoute: typeof AppCompanyIdNotAuthorizedRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/purchase-orders': {
      id: '/_app/$companyId/purchase-orders'
      path: '/$companyId/purchase-orders'
      fullPath: '/$companyId/purchase-orders'
      preLoaderRoute: typeof AppCompanyIdPurchaseOrdersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_appSettings/$companyId/settings': {
      id: '/_appSettings/$companyId/settings'
      path: '/$companyId/settings'
      fullPath: '/$companyId/settings'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_public/work-request/$companyId': {
      id: '/_public/work-request/$companyId'
      path: '/work-request/$companyId'
      fullPath: '/work-request/$companyId'
      preLoaderRoute: typeof PublicWorkRequestCompanyIdRouteImport
      parentRoute: typeof PublicRouteRoute
    }
    '/super-user/bug-reports/': {
      id: '/super-user/bug-reports/'
      path: '/bug-reports'
      fullPath: '/super-user/bug-reports/'
      preLoaderRoute: typeof SuperUserBugReportsIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/companies/': {
      id: '/super-user/companies/'
      path: '/companies'
      fullPath: '/super-user/companies/'
      preLoaderRoute: typeof SuperUserCompaniesIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/companies/$companyId': {
      id: '/super-user/companies/$companyId'
      path: '/companies/$companyId'
      fullPath: '/super-user/companies/$companyId'
      preLoaderRoute: typeof SuperUserCompaniesCompanyIdRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/help-content/': {
      id: '/super-user/help-content/'
      path: '/help-content'
      fullPath: '/super-user/help-content/'
      preLoaderRoute: typeof SuperUserHelpContentIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/permission-defaults/': {
      id: '/super-user/permission-defaults/'
      path: '/permission-defaults'
      fullPath: '/super-user/permission-defaults/'
      preLoaderRoute: typeof SuperUserPermissionDefaultsIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/users/': {
      id: '/super-user/users/'
      path: '/users'
      fullPath: '/super-user/users/'
      preLoaderRoute: typeof SuperUserUsersIndexRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/super-user/users/$userId': {
      id: '/super-user/users/$userId'
      path: '/users/$userId'
      fullPath: '/super-user/users/$userId'
      preLoaderRoute: typeof SuperUserUsersUserIdRouteImport
      parentRoute: typeof SuperUserRouteRoute
    }
    '/_app/$companyId/analytics/': {
      id: '/_app/$companyId/analytics/'
      path: '/'
      fullPath: '/$companyId/analytics/'
      preLoaderRoute: typeof AppCompanyIdAnalyticsIndexRouteImport
      parentRoute: typeof AppCompanyIdAnalyticsRouteRoute
    }
    '/_app/$companyId/analytics/assets': {
      id: '/_app/$companyId/analytics/assets'
      path: '/assets'
      fullPath: '/$companyId/analytics/assets'
      preLoaderRoute: typeof AppCompanyIdAnalyticsAssetsRouteImport
      parentRoute: typeof AppCompanyIdAnalyticsRouteRoute
    }
    '/_app/$companyId/analytics/employees': {
      id: '/_app/$companyId/analytics/employees'
      path: '/employees'
      fullPath: '/$companyId/analytics/employees'
      preLoaderRoute: typeof AppCompanyIdAnalyticsEmployeesRouteImport
      parentRoute: typeof AppCompanyIdAnalyticsRouteRoute
    }
    '/_app/$companyId/analytics/work-orders': {
      id: '/_app/$companyId/analytics/work-orders'
      path: '/work-orders'
      fullPath: '/$companyId/analytics/work-orders'
      preLoaderRoute: typeof AppCompanyIdAnalyticsWorkOrdersRouteImport
      parentRoute: typeof AppCompanyIdAnalyticsRouteRoute
    }
    '/_app/$companyId/assets/': {
      id: '/_app/$companyId/assets/'
      path: '/$companyId/assets'
      fullPath: '/$companyId/assets/'
      preLoaderRoute: typeof AppCompanyIdAssetsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/assets/$assetId': {
      id: '/_app/$companyId/assets/$assetId'
      path: '/$companyId/assets/$assetId'
      fullPath: '/$companyId/assets/$assetId'
      preLoaderRoute: typeof AppCompanyIdAssetsAssetIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/automations/': {
      id: '/_app/$companyId/automations/'
      path: '/$companyId/automations'
      fullPath: '/$companyId/automations/'
      preLoaderRoute: typeof AppCompanyIdAutomationsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/automations/$automationId': {
      id: '/_app/$companyId/automations/$automationId'
      path: '/$companyId/automations/$automationId'
      fullPath: '/$companyId/automations/$automationId'
      preLoaderRoute: typeof AppCompanyIdAutomationsAutomationIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/meters/': {
      id: '/_app/$companyId/meters/'
      path: '/$companyId/meters'
      fullPath: '/$companyId/meters/'
      preLoaderRoute: typeof AppCompanyIdMetersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/meters/$meterId': {
      id: '/_app/$companyId/meters/$meterId'
      path: '/$companyId/meters/$meterId'
      fullPath: '/$companyId/meters/$meterId'
      preLoaderRoute: typeof AppCompanyIdMetersMeterIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/parts/': {
      id: '/_app/$companyId/parts/'
      path: '/$companyId/parts'
      fullPath: '/$companyId/parts/'
      preLoaderRoute: typeof AppCompanyIdPartsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/parts/$partId': {
      id: '/_app/$companyId/parts/$partId'
      path: '/$companyId/parts/$partId'
      fullPath: '/$companyId/parts/$partId'
      preLoaderRoute: typeof AppCompanyIdPartsPartIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/periodic-maintenances/': {
      id: '/_app/$companyId/periodic-maintenances/'
      path: '/$companyId/periodic-maintenances'
      fullPath: '/$companyId/periodic-maintenances/'
      preLoaderRoute: typeof AppCompanyIdPeriodicMaintenancesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/periodic-maintenances/$periodicMaintenanceId': {
      id: '/_app/$companyId/periodic-maintenances/$periodicMaintenanceId'
      path: '/$companyId/periodic-maintenances/$periodicMaintenanceId'
      fullPath: '/$companyId/periodic-maintenances/$periodicMaintenanceId'
      preLoaderRoute: typeof AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/procedures/': {
      id: '/_app/$companyId/procedures/'
      path: '/$companyId/procedures'
      fullPath: '/$companyId/procedures/'
      preLoaderRoute: typeof AppCompanyIdProceduresIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/procedures/$procedureId': {
      id: '/_app/$companyId/procedures/$procedureId'
      path: '/$companyId/procedures/$procedureId'
      fullPath: '/$companyId/procedures/$procedureId'
      preLoaderRoute: typeof AppCompanyIdProceduresProcedureIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/purchase-orders/': {
      id: '/_app/$companyId/purchase-orders/'
      path: '/'
      fullPath: '/$companyId/purchase-orders/'
      preLoaderRoute: typeof AppCompanyIdPurchaseOrdersIndexRouteImport
      parentRoute: typeof AppCompanyIdPurchaseOrdersRouteRoute
    }
    '/_app/$companyId/purchase-orders/$orderId': {
      id: '/_app/$companyId/purchase-orders/$orderId'
      path: '/$orderId'
      fullPath: '/$companyId/purchase-orders/$orderId'
      preLoaderRoute: typeof AppCompanyIdPurchaseOrdersOrderIdRouteImport
      parentRoute: typeof AppCompanyIdPurchaseOrdersRouteRoute
    }
    '/_app/$companyId/vendors/': {
      id: '/_app/$companyId/vendors/'
      path: '/$companyId/vendors'
      fullPath: '/$companyId/vendors/'
      preLoaderRoute: typeof AppCompanyIdVendorsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/vendors/$vendorId': {
      id: '/_app/$companyId/vendors/$vendorId'
      path: '/$companyId/vendors/$vendorId'
      fullPath: '/$companyId/vendors/$vendorId'
      preLoaderRoute: typeof AppCompanyIdVendorsVendorIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-order-templates/': {
      id: '/_app/$companyId/work-order-templates/'
      path: '/$companyId/work-order-templates'
      fullPath: '/$companyId/work-order-templates/'
      preLoaderRoute: typeof AppCompanyIdWorkOrderTemplatesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-order-templates/$templateId': {
      id: '/_app/$companyId/work-order-templates/$templateId'
      path: '/$companyId/work-order-templates/$templateId'
      fullPath: '/$companyId/work-order-templates/$templateId'
      preLoaderRoute: typeof AppCompanyIdWorkOrderTemplatesTemplateIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-orders/': {
      id: '/_app/$companyId/work-orders/'
      path: '/$companyId/work-orders'
      fullPath: '/$companyId/work-orders/'
      preLoaderRoute: typeof AppCompanyIdWorkOrdersIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-orders/$workOrderId': {
      id: '/_app/$companyId/work-orders/$workOrderId'
      path: '/$companyId/work-orders/$workOrderId'
      fullPath: '/$companyId/work-orders/$workOrderId'
      preLoaderRoute: typeof AppCompanyIdWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-requests/': {
      id: '/_app/$companyId/work-requests/'
      path: '/$companyId/work-requests'
      fullPath: '/$companyId/work-requests/'
      preLoaderRoute: typeof AppCompanyIdWorkRequestsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/$companyId/work-requests/$requestId': {
      id: '/_app/$companyId/work-requests/$requestId'
      path: '/$companyId/work-requests/$requestId'
      fullPath: '/$companyId/work-requests/$requestId'
      preLoaderRoute: typeof AppCompanyIdWorkRequestsRequestIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_appSettings/$companyId/settings/': {
      id: '/_appSettings/$companyId/settings/'
      path: '/'
      fullPath: '/$companyId/settings/'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsIndexRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/$panel': {
      id: '/_appSettings/$companyId/settings/$panel'
      path: '/$panel'
      fullPath: '/$companyId/settings/$panel'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsPanelRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/asset-preferences': {
      id: '/_appSettings/$companyId/settings/asset-preferences'
      path: '/asset-preferences'
      fullPath: '/$companyId/settings/asset-preferences'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsAssetPreferencesRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/assets': {
      id: '/_appSettings/$companyId/settings/assets'
      path: '/assets'
      fullPath: '/$companyId/settings/assets'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsAssetsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/bug-reports': {
      id: '/_appSettings/$companyId/settings/bug-reports'
      path: '/bug-reports'
      fullPath: '/$companyId/settings/bug-reports'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsBugReportsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/data-import': {
      id: '/_appSettings/$companyId/settings/data-import'
      path: '/data-import'
      fullPath: '/$companyId/settings/data-import'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsDataImportRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/general': {
      id: '/_appSettings/$companyId/settings/general'
      path: '/general'
      fullPath: '/$companyId/settings/general'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/meters': {
      id: '/_appSettings/$companyId/settings/meters'
      path: '/meters'
      fullPath: '/$companyId/settings/meters'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsMetersRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/notifications': {
      id: '/_appSettings/$companyId/settings/notifications'
      path: '/notifications'
      fullPath: '/$companyId/settings/notifications'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/parts': {
      id: '/_appSettings/$companyId/settings/parts'
      path: '/parts'
      fullPath: '/$companyId/settings/parts'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsPartsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/periodic-maintenances': {
      id: '/_appSettings/$companyId/settings/periodic-maintenances'
      path: '/periodic-maintenances'
      fullPath: '/$companyId/settings/periodic-maintenances'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsPeriodicMaintenancesRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/procedures': {
      id: '/_appSettings/$companyId/settings/procedures'
      path: '/procedures'
      fullPath: '/$companyId/settings/procedures'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsProceduresRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/purchase-orders': {
      id: '/_appSettings/$companyId/settings/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/$companyId/settings/purchase-orders'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsPurchaseOrdersRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/security': {
      id: '/_appSettings/$companyId/settings/security'
      path: '/security'
      fullPath: '/$companyId/settings/security'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/user': {
      id: '/_appSettings/$companyId/settings/user'
      path: '/user'
      fullPath: '/$companyId/settings/user'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsUserRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/users-teams': {
      id: '/_appSettings/$companyId/settings/users-teams'
      path: '/users-teams'
      fullPath: '/$companyId/settings/users-teams'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsUsersTeamsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/vendors': {
      id: '/_appSettings/$companyId/settings/vendors'
      path: '/vendors'
      fullPath: '/$companyId/settings/vendors'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsVendorsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/work-order-templates': {
      id: '/_appSettings/$companyId/settings/work-order-templates'
      path: '/work-order-templates'
      fullPath: '/$companyId/settings/work-order-templates'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsWorkOrderTemplatesRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/work-orders': {
      id: '/_appSettings/$companyId/settings/work-orders'
      path: '/work-orders'
      fullPath: '/$companyId/settings/work-orders'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsWorkOrdersRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_appSettings/$companyId/settings/work-requests': {
      id: '/_appSettings/$companyId/settings/work-requests'
      path: '/work-requests'
      fullPath: '/$companyId/settings/work-requests'
      preLoaderRoute: typeof AppSettingsCompanyIdSettingsWorkRequestsRouteImport
      parentRoute: typeof AppSettingsCompanyIdSettingsRouteRoute
    }
    '/_authentication/sso/microsoft/callback': {
      id: '/_authentication/sso/microsoft/callback'
      path: '/sso/microsoft/callback'
      fullPath: '/sso/microsoft/callback'
      preLoaderRoute: typeof AuthenticationSsoMicrosoftCallbackRouteImport
      parentRoute: typeof AuthenticationRouteRoute
    }
    '/_public/share/work-order/$companyId/$workOrderId': {
      id: '/_public/share/work-order/$companyId/$workOrderId'
      path: '/share/work-order/$companyId/$workOrderId'
      fullPath: '/share/work-order/$companyId/$workOrderId'
      preLoaderRoute: typeof PublicShareWorkOrderCompanyIdWorkOrderIdRouteImport
      parentRoute: typeof PublicRouteRoute
    }
  }
}

interface AppCompanyIdAnalyticsRouteRouteChildren {
  AppCompanyIdAnalyticsAssetsRoute: typeof AppCompanyIdAnalyticsAssetsRoute
  AppCompanyIdAnalyticsEmployeesRoute: typeof AppCompanyIdAnalyticsEmployeesRoute
  AppCompanyIdAnalyticsWorkOrdersRoute: typeof AppCompanyIdAnalyticsWorkOrdersRoute
  AppCompanyIdAnalyticsIndexRoute: typeof AppCompanyIdAnalyticsIndexRoute
}

const AppCompanyIdAnalyticsRouteRouteChildren: AppCompanyIdAnalyticsRouteRouteChildren =
  {
    AppCompanyIdAnalyticsAssetsRoute: AppCompanyIdAnalyticsAssetsRoute,
    AppCompanyIdAnalyticsEmployeesRoute: AppCompanyIdAnalyticsEmployeesRoute,
    AppCompanyIdAnalyticsWorkOrdersRoute: AppCompanyIdAnalyticsWorkOrdersRoute,
    AppCompanyIdAnalyticsIndexRoute: AppCompanyIdAnalyticsIndexRoute,
  }

const AppCompanyIdAnalyticsRouteRouteWithChildren =
  AppCompanyIdAnalyticsRouteRoute._addFileChildren(
    AppCompanyIdAnalyticsRouteRouteChildren,
  )

interface AppCompanyIdPurchaseOrdersRouteRouteChildren {
  AppCompanyIdPurchaseOrdersOrderIdRoute: typeof AppCompanyIdPurchaseOrdersOrderIdRoute
  AppCompanyIdPurchaseOrdersIndexRoute: typeof AppCompanyIdPurchaseOrdersIndexRoute
}

const AppCompanyIdPurchaseOrdersRouteRouteChildren: AppCompanyIdPurchaseOrdersRouteRouteChildren =
  {
    AppCompanyIdPurchaseOrdersOrderIdRoute:
      AppCompanyIdPurchaseOrdersOrderIdRoute,
    AppCompanyIdPurchaseOrdersIndexRoute: AppCompanyIdPurchaseOrdersIndexRoute,
  }

const AppCompanyIdPurchaseOrdersRouteRouteWithChildren =
  AppCompanyIdPurchaseOrdersRouteRoute._addFileChildren(
    AppCompanyIdPurchaseOrdersRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppCompanyIdAnalyticsRouteRoute: typeof AppCompanyIdAnalyticsRouteRouteWithChildren
  AppCompanyIdPurchaseOrdersRouteRoute: typeof AppCompanyIdPurchaseOrdersRouteRouteWithChildren
  AppCompanyIdHelpRoute: typeof AppCompanyIdHelpRoute
  AppCompanyIdNotAuthorizedRoute: typeof AppCompanyIdNotAuthorizedRoute
  AppCompanyIdIndexRoute: typeof AppCompanyIdIndexRoute
  AppCompanyIdAssetsAssetIdRoute: typeof AppCompanyIdAssetsAssetIdRoute
  AppCompanyIdAutomationsAutomationIdRoute: typeof AppCompanyIdAutomationsAutomationIdRoute
  AppCompanyIdMetersMeterIdRoute: typeof AppCompanyIdMetersMeterIdRoute
  AppCompanyIdPartsPartIdRoute: typeof AppCompanyIdPartsPartIdRoute
  AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute: typeof AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute
  AppCompanyIdProceduresProcedureIdRoute: typeof AppCompanyIdProceduresProcedureIdRoute
  AppCompanyIdVendorsVendorIdRoute: typeof AppCompanyIdVendorsVendorIdRoute
  AppCompanyIdWorkOrderTemplatesTemplateIdRoute: typeof AppCompanyIdWorkOrderTemplatesTemplateIdRoute
  AppCompanyIdWorkOrdersWorkOrderIdRoute: typeof AppCompanyIdWorkOrdersWorkOrderIdRoute
  AppCompanyIdWorkRequestsRequestIdRoute: typeof AppCompanyIdWorkRequestsRequestIdRoute
  AppCompanyIdAssetsIndexRoute: typeof AppCompanyIdAssetsIndexRoute
  AppCompanyIdAutomationsIndexRoute: typeof AppCompanyIdAutomationsIndexRoute
  AppCompanyIdMetersIndexRoute: typeof AppCompanyIdMetersIndexRoute
  AppCompanyIdPartsIndexRoute: typeof AppCompanyIdPartsIndexRoute
  AppCompanyIdPeriodicMaintenancesIndexRoute: typeof AppCompanyIdPeriodicMaintenancesIndexRoute
  AppCompanyIdProceduresIndexRoute: typeof AppCompanyIdProceduresIndexRoute
  AppCompanyIdVendorsIndexRoute: typeof AppCompanyIdVendorsIndexRoute
  AppCompanyIdWorkOrderTemplatesIndexRoute: typeof AppCompanyIdWorkOrderTemplatesIndexRoute
  AppCompanyIdWorkOrdersIndexRoute: typeof AppCompanyIdWorkOrdersIndexRoute
  AppCompanyIdWorkRequestsIndexRoute: typeof AppCompanyIdWorkRequestsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppCompanyIdAnalyticsRouteRoute: AppCompanyIdAnalyticsRouteRouteWithChildren,
  AppCompanyIdPurchaseOrdersRouteRoute:
    AppCompanyIdPurchaseOrdersRouteRouteWithChildren,
  AppCompanyIdHelpRoute: AppCompanyIdHelpRoute,
  AppCompanyIdNotAuthorizedRoute: AppCompanyIdNotAuthorizedRoute,
  AppCompanyIdIndexRoute: AppCompanyIdIndexRoute,
  AppCompanyIdAssetsAssetIdRoute: AppCompanyIdAssetsAssetIdRoute,
  AppCompanyIdAutomationsAutomationIdRoute:
    AppCompanyIdAutomationsAutomationIdRoute,
  AppCompanyIdMetersMeterIdRoute: AppCompanyIdMetersMeterIdRoute,
  AppCompanyIdPartsPartIdRoute: AppCompanyIdPartsPartIdRoute,
  AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute:
    AppCompanyIdPeriodicMaintenancesPeriodicMaintenanceIdRoute,
  AppCompanyIdProceduresProcedureIdRoute:
    AppCompanyIdProceduresProcedureIdRoute,
  AppCompanyIdVendorsVendorIdRoute: AppCompanyIdVendorsVendorIdRoute,
  AppCompanyIdWorkOrderTemplatesTemplateIdRoute:
    AppCompanyIdWorkOrderTemplatesTemplateIdRoute,
  AppCompanyIdWorkOrdersWorkOrderIdRoute:
    AppCompanyIdWorkOrdersWorkOrderIdRoute,
  AppCompanyIdWorkRequestsRequestIdRoute:
    AppCompanyIdWorkRequestsRequestIdRoute,
  AppCompanyIdAssetsIndexRoute: AppCompanyIdAssetsIndexRoute,
  AppCompanyIdAutomationsIndexRoute: AppCompanyIdAutomationsIndexRoute,
  AppCompanyIdMetersIndexRoute: AppCompanyIdMetersIndexRoute,
  AppCompanyIdPartsIndexRoute: AppCompanyIdPartsIndexRoute,
  AppCompanyIdPeriodicMaintenancesIndexRoute:
    AppCompanyIdPeriodicMaintenancesIndexRoute,
  AppCompanyIdProceduresIndexRoute: AppCompanyIdProceduresIndexRoute,
  AppCompanyIdVendorsIndexRoute: AppCompanyIdVendorsIndexRoute,
  AppCompanyIdWorkOrderTemplatesIndexRoute:
    AppCompanyIdWorkOrderTemplatesIndexRoute,
  AppCompanyIdWorkOrdersIndexRoute: AppCompanyIdWorkOrdersIndexRoute,
  AppCompanyIdWorkRequestsIndexRoute: AppCompanyIdWorkRequestsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AppSettingsCompanyIdSettingsRouteRouteChildren {
  AppSettingsCompanyIdSettingsPanelRoute: typeof AppSettingsCompanyIdSettingsPanelRoute
  AppSettingsCompanyIdSettingsAssetPreferencesRoute: typeof AppSettingsCompanyIdSettingsAssetPreferencesRoute
  AppSettingsCompanyIdSettingsAssetsRoute: typeof AppSettingsCompanyIdSettingsAssetsRoute
  AppSettingsCompanyIdSettingsBugReportsRoute: typeof AppSettingsCompanyIdSettingsBugReportsRoute
  AppSettingsCompanyIdSettingsDataImportRoute: typeof AppSettingsCompanyIdSettingsDataImportRoute
  AppSettingsCompanyIdSettingsGeneralRoute: typeof AppSettingsCompanyIdSettingsGeneralRoute
  AppSettingsCompanyIdSettingsMetersRoute: typeof AppSettingsCompanyIdSettingsMetersRoute
  AppSettingsCompanyIdSettingsNotificationsRoute: typeof AppSettingsCompanyIdSettingsNotificationsRoute
  AppSettingsCompanyIdSettingsPartsRoute: typeof AppSettingsCompanyIdSettingsPartsRoute
  AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute: typeof AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute
  AppSettingsCompanyIdSettingsProceduresRoute: typeof AppSettingsCompanyIdSettingsProceduresRoute
  AppSettingsCompanyIdSettingsPurchaseOrdersRoute: typeof AppSettingsCompanyIdSettingsPurchaseOrdersRoute
  AppSettingsCompanyIdSettingsSecurityRoute: typeof AppSettingsCompanyIdSettingsSecurityRoute
  AppSettingsCompanyIdSettingsUserRoute: typeof AppSettingsCompanyIdSettingsUserRoute
  AppSettingsCompanyIdSettingsUsersTeamsRoute: typeof AppSettingsCompanyIdSettingsUsersTeamsRoute
  AppSettingsCompanyIdSettingsVendorsRoute: typeof AppSettingsCompanyIdSettingsVendorsRoute
  AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute: typeof AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute
  AppSettingsCompanyIdSettingsWorkOrdersRoute: typeof AppSettingsCompanyIdSettingsWorkOrdersRoute
  AppSettingsCompanyIdSettingsWorkRequestsRoute: typeof AppSettingsCompanyIdSettingsWorkRequestsRoute
  AppSettingsCompanyIdSettingsIndexRoute: typeof AppSettingsCompanyIdSettingsIndexRoute
}

const AppSettingsCompanyIdSettingsRouteRouteChildren: AppSettingsCompanyIdSettingsRouteRouteChildren =
  {
    AppSettingsCompanyIdSettingsPanelRoute:
      AppSettingsCompanyIdSettingsPanelRoute,
    AppSettingsCompanyIdSettingsAssetPreferencesRoute:
      AppSettingsCompanyIdSettingsAssetPreferencesRoute,
    AppSettingsCompanyIdSettingsAssetsRoute:
      AppSettingsCompanyIdSettingsAssetsRoute,
    AppSettingsCompanyIdSettingsBugReportsRoute:
      AppSettingsCompanyIdSettingsBugReportsRoute,
    AppSettingsCompanyIdSettingsDataImportRoute:
      AppSettingsCompanyIdSettingsDataImportRoute,
    AppSettingsCompanyIdSettingsGeneralRoute:
      AppSettingsCompanyIdSettingsGeneralRoute,
    AppSettingsCompanyIdSettingsMetersRoute:
      AppSettingsCompanyIdSettingsMetersRoute,
    AppSettingsCompanyIdSettingsNotificationsRoute:
      AppSettingsCompanyIdSettingsNotificationsRoute,
    AppSettingsCompanyIdSettingsPartsRoute:
      AppSettingsCompanyIdSettingsPartsRoute,
    AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute:
      AppSettingsCompanyIdSettingsPeriodicMaintenancesRoute,
    AppSettingsCompanyIdSettingsProceduresRoute:
      AppSettingsCompanyIdSettingsProceduresRoute,
    AppSettingsCompanyIdSettingsPurchaseOrdersRoute:
      AppSettingsCompanyIdSettingsPurchaseOrdersRoute,
    AppSettingsCompanyIdSettingsSecurityRoute:
      AppSettingsCompanyIdSettingsSecurityRoute,
    AppSettingsCompanyIdSettingsUserRoute:
      AppSettingsCompanyIdSettingsUserRoute,
    AppSettingsCompanyIdSettingsUsersTeamsRoute:
      AppSettingsCompanyIdSettingsUsersTeamsRoute,
    AppSettingsCompanyIdSettingsVendorsRoute:
      AppSettingsCompanyIdSettingsVendorsRoute,
    AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute:
      AppSettingsCompanyIdSettingsWorkOrderTemplatesRoute,
    AppSettingsCompanyIdSettingsWorkOrdersRoute:
      AppSettingsCompanyIdSettingsWorkOrdersRoute,
    AppSettingsCompanyIdSettingsWorkRequestsRoute:
      AppSettingsCompanyIdSettingsWorkRequestsRoute,
    AppSettingsCompanyIdSettingsIndexRoute:
      AppSettingsCompanyIdSettingsIndexRoute,
  }

const AppSettingsCompanyIdSettingsRouteRouteWithChildren =
  AppSettingsCompanyIdSettingsRouteRoute._addFileChildren(
    AppSettingsCompanyIdSettingsRouteRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsCompanyIdSettingsRouteRoute: typeof AppSettingsCompanyIdSettingsRouteRouteWithChildren
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsCompanyIdSettingsRouteRoute:
    AppSettingsCompanyIdSettingsRouteRouteWithChildren,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AuthenticationRouteRouteChildren {
  AuthenticationForgotPasswordRoute: typeof AuthenticationForgotPasswordRoute
  AuthenticationLoginRoute: typeof AuthenticationLoginRoute
  AuthenticationLogoutRoute: typeof AuthenticationLogoutRoute
  AuthenticationResetPasswordRoute: typeof AuthenticationResetPasswordRoute
  AuthenticationSsoMicrosoftCallbackRoute: typeof AuthenticationSsoMicrosoftCallbackRoute
}

const AuthenticationRouteRouteChildren: AuthenticationRouteRouteChildren = {
  AuthenticationForgotPasswordRoute: AuthenticationForgotPasswordRoute,
  AuthenticationLoginRoute: AuthenticationLoginRoute,
  AuthenticationLogoutRoute: AuthenticationLogoutRoute,
  AuthenticationResetPasswordRoute: AuthenticationResetPasswordRoute,
  AuthenticationSsoMicrosoftCallbackRoute:
    AuthenticationSsoMicrosoftCallbackRoute,
}

const AuthenticationRouteRouteWithChildren =
  AuthenticationRouteRoute._addFileChildren(AuthenticationRouteRouteChildren)

interface PublicRouteRouteChildren {
  PublicAcceptInvitationRoute: typeof PublicAcceptInvitationRoute
  PublicHandleRoute: typeof PublicHandleRoute
  PublicWorkRequestCompanyIdRoute: typeof PublicWorkRequestCompanyIdRoute
  PublicShareWorkOrderCompanyIdWorkOrderIdRoute: typeof PublicShareWorkOrderCompanyIdWorkOrderIdRoute
}

const PublicRouteRouteChildren: PublicRouteRouteChildren = {
  PublicAcceptInvitationRoute: PublicAcceptInvitationRoute,
  PublicHandleRoute: PublicHandleRoute,
  PublicWorkRequestCompanyIdRoute: PublicWorkRequestCompanyIdRoute,
  PublicShareWorkOrderCompanyIdWorkOrderIdRoute:
    PublicShareWorkOrderCompanyIdWorkOrderIdRoute,
}

const PublicRouteRouteWithChildren = PublicRouteRoute._addFileChildren(
  PublicRouteRouteChildren,
)

interface SettingsRouteRouteChildren {
  SettingsSecurityRoute: typeof SettingsSecurityRoute
  SettingsUserRoute: typeof SettingsUserRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteRouteChildren: SettingsRouteRouteChildren = {
  SettingsSecurityRoute: SettingsSecurityRoute,
  SettingsUserRoute: SettingsUserRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteRouteWithChildren = SettingsRouteRoute._addFileChildren(
  SettingsRouteRouteChildren,
)

interface SuperUserRouteRouteChildren {
  SuperUserIndexRoute: typeof SuperUserIndexRoute
  SuperUserCompaniesCompanyIdRoute: typeof SuperUserCompaniesCompanyIdRoute
  SuperUserUsersUserIdRoute: typeof SuperUserUsersUserIdRoute
  SuperUserBugReportsIndexRoute: typeof SuperUserBugReportsIndexRoute
  SuperUserCompaniesIndexRoute: typeof SuperUserCompaniesIndexRoute
  SuperUserHelpContentIndexRoute: typeof SuperUserHelpContentIndexRoute
  SuperUserPermissionDefaultsIndexRoute: typeof SuperUserPermissionDefaultsIndexRoute
  SuperUserUsersIndexRoute: typeof SuperUserUsersIndexRoute
}

const SuperUserRouteRouteChildren: SuperUserRouteRouteChildren = {
  SuperUserIndexRoute: SuperUserIndexRoute,
  SuperUserCompaniesCompanyIdRoute: SuperUserCompaniesCompanyIdRoute,
  SuperUserUsersUserIdRoute: SuperUserUsersUserIdRoute,
  SuperUserBugReportsIndexRoute: SuperUserBugReportsIndexRoute,
  SuperUserCompaniesIndexRoute: SuperUserCompaniesIndexRoute,
  SuperUserHelpContentIndexRoute: SuperUserHelpContentIndexRoute,
  SuperUserPermissionDefaultsIndexRoute: SuperUserPermissionDefaultsIndexRoute,
  SuperUserUsersIndexRoute: SuperUserUsersIndexRoute,
}

const SuperUserRouteRouteWithChildren = SuperUserRouteRoute._addFileChildren(
  SuperUserRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AuthenticationRouteRoute: AuthenticationRouteRouteWithChildren,
  PublicRouteRoute: PublicRouteRouteWithChildren,
  SettingsRouteRoute: SettingsRouteRouteWithChildren,
  SuperUserRouteRoute: SuperUserRouteRouteWithChildren,
  SettingsUsersRoute: SettingsUsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
